// extracted by mini-css-extract-plugin
export default {"wrapper":"Delivery_wrapper__G2lmg","header":"Delivery_header__0FQqS","goBack":"Delivery_goBack__Mrhoa","container":"Delivery_container__rhEaj"};